import { Box, Grid, Typography, useTheme } from '@mui/material';

import { GiftTypeEnum } from 'src/components/domain/gift-type-selection/GiftTypeSelections';
import { useLocale, getLocaleNumberFormatTwoDecimals } from '@repo/i18n';
import { capitalize } from '@repo/common-utils/TextUtils';
import { TZDate } from '@repo/tzdate';

import type { JSX } from 'react';

interface IProps {
    largeScreen: boolean;
    giftcardTotal: number;
    selectedGiftType: GiftTypeEnum | null;
    expiryDate?: TZDate;
}

export default function SummaryGiftcardBooking(props: IProps): JSX.Element {
    const { locale, t } = useLocale();
    const theme = useTheme();

    return (
        <Box>
            <Box>
                <Grid
                    container
                    direction="row"
                    wrap="nowrap"
                    justifyContent="space-between"
                    borderBottom={`1px solid ${theme.palette.grey[400]}`}
                    m={theme.spacing(2, 0, 0.5, 0)}
                >
                    <Box>
                        <Typography variant="h6" align="left" color="textSecondary">
                            {capitalize(t.gift_card)}
                        </Typography>
                    </Box>
                </Grid>

                <Box sx={{ margin: theme.spacing(0.5, 0, 2, 0) }}>
                    <Grid container direction="row" justifyContent="space-between" wrap="nowrap">
                        <Grid container direction="column">
                            <Typography align="left" color="textSecondary">
                                {props.selectedGiftType === GiftTypeEnum.Print
                                    ? capitalize(t.purchased_giftcard.self)
                                    : capitalize(t.purchased_giftcard.recipient)}
                            </Typography>
                            {props.expiryDate && (
                                <Typography align="left" color="textPrimary">
                                    <Box component="span" fontWeight="light" fontSize="12px">
                                        {capitalize(t.valid_until)}:{' '}
                                        {props.expiryDate.format('YYYY-MM-DD')}
                                    </Box>
                                </Typography>
                            )}
                        </Grid>
                        <Typography align="right" color="textSecondary">
                            {getLocaleNumberFormatTwoDecimals(locale, props.giftcardTotal)}
                        </Typography>
                    </Grid>
                </Box>
            </Box>
        </Box>
    );
}
